import React, {
  useRef,
  useCallback,
  //useState 
} from 'react';

import UtilImage from '../utils/util-image'

import { Pagination, A11y, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import {
  Segment,
  Card,
  Icon,
} from 'semantic-ui-react';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

export default function ContentSlider(props) {
  //console.log('ContentSlider - props', props);

  const sliderRef = useRef(null);

  const {
    //contentItemId,
    variationType,
    contentSliderSlides,
  } = props;

  //console.log('ContentSlider - props.content_collection', props.content_collection);

  //const textColor = props.text_color ? props.text_color : props.header_text_color ? props.header_text_color : null;

  /* const [activeIndex, setActiveIndex] = useState(0);

  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    if (index !== activeIndex) {
      const newIndex = activeIndex === index ? -1 : index;
      setActiveIndex(newIndex);
    }
  } */

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);
  
  return (
    <>
      {/* <style dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize([
          '#layout-wrapper a.ui.button.postUpSignUpButton {',
          '  color: '+ textColor +';',
          '  box-shadow: inset 0 0 0 2px '+ textColor +' !important;',
          '}',
          '#layout-wrapper a.ui.button.postUpSignUpButton:hover {',
          '  color: '+ props.header_background_color +' !important;',
          '  background: '+ textColor +' !important;',
          '}'
          ].join('\n'))
        }}>
      </style> */}
      <div className={'site-content-slider ' + (variationType ? variationType : null)}>
        <Segment basic>
          <Swiper ref={sliderRef}
            modules={[Pagination, A11y, Navigation]}
            //navigation={true}
            slidesPerView={'auto'}
            loop={true}
            centeredSlides={true}
            spaceBetween={50}
            initialSlide={1}
            pagination={{ clickable: true }}
            onSlideChange={() => {
              //console.debug('slide change')
            }}
            onSwiper={(swiper) => {
              //console.debug(swiper)
            }}
          >
            {contentSliderSlides && contentSliderSlides.contentItems.length !== 0 && contentSliderSlides.contentItems.map((contentSliderSlide, i) => {
              const imageAltText = contentSliderSlide.displayText +' image';
              //console.debug('contentSliderSlide', contentSliderSlide);
              return (
                <SwiperSlide key={i}>
                  <Card>
                    <Card.Content>
                      <Card.Header>
                        {contentSliderSlide.image ?
                          <UtilImage altText={imageAltText} image={contentSliderSlide.image} semanticProps={{ size: 'small', }} />
                        :
                          null
                        }
                        {/* <Image size={'small'} src={contentSliderSlide.image.imageAbsoluteUrls[0]} /> */}
                      </Card.Header>
                      <Card.Description>
                        {contentSliderSlide.contentText}
                      </Card.Description>
                    </Card.Content>
                    <Card.Content extra>
                      {variationType === 'testimonial' ?
                        <Icon size={'large'} name={'quote left'} />
                      :
                        null
                      }
                      {/* {props.renderSource === 'SectionHomepageTestimonials' ?
                        <Icon size={'large'} name={'quote left'} />
                      :
                        null
                      } */}
                      <h4>{contentSliderSlide.content2}</h4>
                      <p>{contentSliderSlide.content3}</p>
                    </Card.Content>
                  </Card>
                </SwiperSlide>
              )
            })}
          </Swiper>
          <div className="swiper-button-prev" onClick={handlePrev} onKeyDown={handlePrev} role='button' aria-label="previous button" tabIndex={-2} />
          <div className="swiper-button-next" onClick={handleNext} onKeyDown={handleNext} role='button' aria-label="next button" tabIndex={-1} />
        </Segment>
      </div>      
    </>
  )
}
